import { AppState } from "../reducers";
import { makeSubstateAccessorCreator } from "../utilities/selectors_util";

const getCommissionStatementState = (state: AppState) => state.commissionStatement;
const createAgentCommissionStatementAccessor = makeSubstateAccessorCreator(getCommissionStatementState);

export const getCommissionStatementDates = (state: AppState) => state.commissionStatement.agentCommissionStatementDates;
export const getCommissionStatementSummary = (state: AppState) => state.commissionStatement.agentCommissionStatementSummary;